var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-list-page',{attrs:{"content-type":"post"}})
}
var staticRenderFns = []

export { render, staticRenderFns }